import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AiIcon } from 'assets/icons/ai.svg';
import { ReactComponent as SwimlaneIcon } from 'assets/icons/box-select.svg';
import { ReactComponent as OwnOperationIcon } from 'assets/icons/factory.svg';
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg';
import { ReactComponent as InputProductIcon } from 'assets/icons/product.svg';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ReactComponent as ScenarioIcon } from 'assets/icons/scenario.svg';
import { ReactComponent as CustomerIcon } from 'assets/icons/user-check.svg';
import { ReactComponent as SupplierIcon } from 'assets/icons/warehouse.svg';
import clsx from 'clsx';

import { VALUE_CHAIN_PANEL_NODES_TYPES } from '../../../../../../constants/interfaces';
import { useDnD } from './DndContext';

import type { TValueChainPanelNodesType } from '../../../../../../constants/interfaces';
import type { IRightPanel } from '../../interfaces/IRightPanel';

import styles from '../sass/RightPanel.module.scss';

function RightPanel({
  isAccessDisabled,
  onClickFilters,
  onClickScenarios,
  selectedFilter,
  onClickAIPanel,
  isScenarioViewMode,
}: IRightPanel) {
  const { t } = useTranslation();
  const [, setPanelType] = useDnD();

  const onDragStart = (event: React.DragEvent<HTMLLIElement>, nodeType: TValueChainPanelNodesType) => {
    if (isScenarioViewMode) {
      event.preventDefault();
      return;
    }
    if (setPanelType) {
      setPanelType(nodeType);
    }
    const { dataTransfer } = event;
    dataTransfer.effectAllowed = 'move';
  };
  let ACTIONS = [{
    id: VALUE_CHAIN_PANEL_NODES_TYPES.FILTER,
    labelKey: 'valueChainMap.filter',
    onPress: onClickFilters,
    icon: <FilterIcon />,
  },
  {
    id: VALUE_CHAIN_PANEL_NODES_TYPES.SCENARIO,
    labelKey: 'valueChainMap.scenario',
    onPress: onClickScenarios,
    icon: <ScenarioIcon />,
  },
  {
    id: VALUE_CHAIN_PANEL_NODES_TYPES.AI,
    labelKey: 'valueChainMap.ai',
    onPress: onClickAIPanel,
    icon: <AiIcon />,
  },
  // hide button Profit center
  // {
  //   id: VALUE_CHAIN_PANEL_NODES_TYPES.PROFIT_CENTER,
  //   labelKey: 'valueChainMap.profitCenter',
  //   onPress: () => {},
  //   onDragStart: (event: React.DragEvent<HTMLLIElement>) => {
  //     onDragStart(event, VALUE_CHAIN_PANEL_NODES_TYPES.PROFIT_CENTER);
  //   },
  //   icon: <ProfitCenterIcon width={24} height={24} />,
  // },
  {
    id: VALUE_CHAIN_PANEL_NODES_TYPES.BALANCE_SHEET_ASSET,
    labelKey: 'valueChainMap.ownOperation',
    onPress: () => {},
    onDragStart: (event: React.DragEvent<HTMLLIElement>) => {
      onDragStart(event, VALUE_CHAIN_PANEL_NODES_TYPES.BALANCE_SHEET_ASSET);
    },
    icon: <OwnOperationIcon width={24} height={24} />,
  }, {
    id: VALUE_CHAIN_PANEL_NODES_TYPES.SUPPLIER,
    labelKey: 'valueChainMap.supplier',
    onPress: () => {},
    onDragStart: (event: React.DragEvent<HTMLLIElement>) => {
      onDragStart(event, VALUE_CHAIN_PANEL_NODES_TYPES.SUPPLIER);
    },
    icon: <SupplierIcon />,
  },
  {
    id: VALUE_CHAIN_PANEL_NODES_TYPES.INPUT_PRODUCT,
    labelKey: 'valueChainMap.product',
    onPress: () => {},
    onDragStart: (event: React.DragEvent<HTMLLIElement>) => {
      onDragStart(event, VALUE_CHAIN_PANEL_NODES_TYPES.INPUT_PRODUCT);
    },
    icon: <InputProductIcon />,
  }, {
    id: VALUE_CHAIN_PANEL_NODES_TYPES.CUSTOMER,
    labelKey: 'valueChainMap.customer',
    onPress: () => {},
    onDragStart: (event: React.DragEvent<HTMLLIElement>) => {
      onDragStart(event, VALUE_CHAIN_PANEL_NODES_TYPES.CUSTOMER);
    },
    icon: <CustomerIcon />,
  }, {
    id: VALUE_CHAIN_PANEL_NODES_TYPES.SWIMLANE,
    labelKey: 'valueChainMap.swimlane',
    onPress: () => {},
    onDragStart: (event: React.DragEvent<HTMLLIElement>) => onDragStart(event, VALUE_CHAIN_PANEL_NODES_TYPES.SWIMLANE),
    icon: <SwimlaneIcon />,
  }];

  if (isAccessDisabled) {
    ACTIONS = ACTIONS.filter((action) => action.id === VALUE_CHAIN_PANEL_NODES_TYPES.FILTER);
  }

  return (
    <ul className={clsx(styles.container, {
      [styles.aloneElement]: isAccessDisabled,
    })}
    >
      {ACTIONS.map(({
        id, icon, labelKey, onPress,
      }) => (
        <li
          key={`actions_${id}`}
          onDragStart={(event) => onDragStart(event, id)}
          onDragEnd={() => setPanelType('')}
          draggable={!isScenarioViewMode
            && id !== VALUE_CHAIN_PANEL_NODES_TYPES.FILTER
            && id !== VALUE_CHAIN_PANEL_NODES_TYPES.AI
            && id !== VALUE_CHAIN_PANEL_NODES_TYPES.SCENARIO}
        >
          <button
            key={id}
            onClick={onPress}
            type="button"
            className={styles.actionWrapper}
            aria-label={t(labelKey)}
            data-i18n-key={labelKey}
          >
            <span className={styles.iconWrapper}>
              {icon}
            </span>
            <span className={styles.tooltipLabel}>{t(labelKey)}</span>
          </button>
          {selectedFilter ? <div className={styles.redDot} /> : null}
        </li>
      ))}
    </ul>
  );
}

export default RightPanel;
